import React from "react";
import { Form, Col } from "react-bootstrap";
import FilterationBarContainer from "../../../components/FilterationBarContainer";
import CustomReactSelect from "../../../components/CustomReactSelect";

const SelectCriteriaForm = (props) => {
  const { supervisorsEmpList, selectedSupEmp, onSupEmpChange } = props;

  return (
    <FilterationBarContainer>
      <Col lg={4}>
        <Form.Group className="input-field">
          <Form.Label className="label">Employee Name</Form.Label>
          <Col>
            <CustomReactSelect
              options={supervisorsEmpList}
              value={selectedSupEmp}
              onChange={(value) => onSupEmpChange(value)}
            />
          </Col>
        </Form.Group>
      </Col>
    </FilterationBarContainer>
  );
};

export default SelectCriteriaForm;
